export const contentTableConfig = {
  title: '荐股统计',
  propList: [
    {
      prop: 'code',
      label: '股票代码',
      minWidth: '100',
      slotName: 'stockCode',
      isFixed: true
    },
    {
      prop: 'name',
      label: '股票名称',
      minWidth: '80',
      isFixed: true,
      slotName: 'name'
    },
    {
      prop: 'date',
      label: '荐股日期',
      minWidth: '120',
      isFixed: true,
      sortable: true
    },
    { prop: 'belong', label: '归属模块', minWidth: '150' },
    {
      prop: 'profit',
      label: '持股至今收益',
      minWidth: '80',
      slotName: 'profit',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.profit.replace('%', '')) / 100 -
          parseFloat(b.profit.replace('%', '')) / 100
        )
      }
    },
    {
      prop: 'zfHigh',
      label: '荐股次日至今最大收益',
      minWidth: '110',
      slotName: 'zfHigh',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.zfHigh.replace('%', '')) / 100 -
          parseFloat(b.zfHigh.replace('%', '')) / 100
        )
      }
    },
    {
      label: '荐股至最大黄带结束时收益',
      minWidth: '120',
      prop: 'zf0',
      slotName: 'zf0',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.zf0.replace('%', '')) / 100 -
          parseFloat(b.zf0.replace('%', '')) / 100
        )
      }
    },
    {
      label: '最大黄带区间收益',
      minWidth: '80',
      prop: 'zf',
      slotName: 'zf',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.zf.replace('%', '')) / 100 -
          parseFloat(b.zf.replace('%', '')) / 100
        )
      }
    },
    { prop: 'range', label: '最大黄带区间', minWidth: '200' },
    { prop: 'belongTo', label: '推荐老师', minWidth: '120' },
    {
      prop: 'signalTitle',
      label: '信号说明',
      minWidth: '400',
      slotName: 'signalTitle'
    },
    { label: '操作', minWidth: '180', slotName: 'handler', isFixed: 'right' }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/ybwave/dataImport'
}
